import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Selection as $e40ea825a81a3709$export$52baac22726c72bf } from "./Selection.module.js";
import { compareNodeOrder as $jkhUT$compareNodeOrder, getFirstItem as $jkhUT$getFirstItem, getChildNodes as $jkhUT$getChildNodes } from "@react-stately/collections";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $d496c0a20b6e58ec$export$6c8a5aaad13c9852 = /*#__PURE__*/function () {
  _createClass($d496c0a20b6e58ec$export$6c8a5aaad13c9852, [{
    key: "setSelectionBehavior",
    /**
    * Sets the selection behavior for the collection.
    */
    value: function setSelectionBehavior(selectionBehavior) {
      this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
    * Whether the collection is currently focused.
    */
  }, {
    key: "setFocused",
    /**
    * Sets whether the collection is focused.
    */
    value: function setFocused(isFocused) {
      this.state.setFocused(isFocused);
    }
    /**
    * The current focused key in the collection.
    */
  }, {
    key: "setFocusedKey",
    /**
    * Sets the focused key.
    */
    value: function setFocusedKey(key, childFocusStrategy) {
      if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
    * The currently selected keys in the collection.
    */
  }, {
    key: "isSelected",
    /**
    * Returns whether a key is selected.
    */
    value: function isSelected(key) {
      if (this.state.selectionMode === 'none') return false;
      var mappedKey = this.getKey(key);
      if (mappedKey == null) return false;
      return this.state.selectedKeys === 'all' ? this.canSelectItem(mappedKey) : this.state.selectedKeys.has(mappedKey);
    }
    /**
    * Whether the selection is empty.
    */
  }, {
    key: "extendSelection",
    /**
    * Extends the selection to the given key.
    */
    value: function extendSelection(toKey) {
      if (this.selectionMode === 'none') return;
      if (this.selectionMode === 'single') {
        this.replaceSelection(toKey);
        return;
      }
      var mappedToKey = this.getKey(toKey);
      if (mappedToKey == null) return;
      var selection;
      // Only select the one key if coming from a select all.
      if (this.state.selectedKeys === 'all') selection = new (0, $e40ea825a81a3709$export$52baac22726c72bf)([mappedToKey], mappedToKey, mappedToKey);else {
        var selectedKeys = this.state.selectedKeys;
        var _selectedKeys_anchorKey;
        var anchorKey = (_selectedKeys_anchorKey = selectedKeys.anchorKey) !== null && _selectedKeys_anchorKey !== void 0 ? _selectedKeys_anchorKey : mappedToKey;
        selection = new (0, $e40ea825a81a3709$export$52baac22726c72bf)(selectedKeys, anchorKey, mappedToKey);
        var _selectedKeys_currentKey;
        var _iterator = _createForOfIteratorHelper(this.getKeyRange(anchorKey, (_selectedKeys_currentKey = selectedKeys.currentKey) !== null && _selectedKeys_currentKey !== void 0 ? _selectedKeys_currentKey : mappedToKey)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            selection.delete(key);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var _iterator2 = _createForOfIteratorHelper(this.getKeyRange(mappedToKey, anchorKey)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _key = _step2.value;
            if (this.canSelectItem(_key)) selection.add(_key);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getKeyRange",
    value: function getKeyRange(from, to) {
      var fromItem = this.collection.getItem(from);
      var toItem = this.collection.getItem(to);
      if (fromItem && toItem) {
        if ((0, $jkhUT$compareNodeOrder)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
        return this.getKeyRangeInternal(to, from);
      }
      return [];
    }
  }, {
    key: "getKeyRangeInternal",
    value: function getKeyRangeInternal(from, to) {
      var _this_layoutDelegate;
      if ((_this_layoutDelegate = this.layoutDelegate) === null || _this_layoutDelegate === void 0 ? void 0 : _this_layoutDelegate.getKeyRange) return this.layoutDelegate.getKeyRange(from, to);
      var keys = [];
      var key = from;
      while (key != null) {
        var item = this.collection.getItem(key);
        if (item && (item.type === 'item' || item.type === 'cell' && this.allowsCellSelection)) keys.push(key);
        if (key === to) return keys;
        key = this.collection.getKeyAfter(key);
      }
      return [];
    }
  }, {
    key: "getKey",
    value: function getKey(key) {
      var item = this.collection.getItem(key);
      if (!item)
        // ¯\_(ツ)_/¯
        return key;
      // If cell selection is allowed, just return the key.
      if (item.type === 'cell' && this.allowsCellSelection) return key;
      // Find a parent item to select
      while (item && item.type !== 'item' && item.parentKey != null) item = this.collection.getItem(item.parentKey);
      if (!item || item.type !== 'item') return null;
      return item.key;
    }
    /**
    * Toggles whether the given key is selected.
    */
  }, {
    key: "toggleSelection",
    value: function toggleSelection(key) {
      if (this.selectionMode === 'none') return;
      if (this.selectionMode === 'single' && !this.isSelected(key)) {
        this.replaceSelection(key);
        return;
      }
      var mappedKey = this.getKey(key);
      if (mappedKey == null) return;
      var keys = new (0, $e40ea825a81a3709$export$52baac22726c72bf)(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
      if (keys.has(mappedKey)) keys.delete(mappedKey);else if (this.canSelectItem(mappedKey)) {
        keys.add(mappedKey);
        keys.anchorKey = mappedKey;
        keys.currentKey = mappedKey;
      }
      if (this.disallowEmptySelection && keys.size === 0) return;
      this.state.setSelectedKeys(keys);
    }
    /**
    * Replaces the selection with only the given key.
    */
  }, {
    key: "replaceSelection",
    value: function replaceSelection(key) {
      if (this.selectionMode === 'none') return;
      var mappedKey = this.getKey(key);
      if (mappedKey == null) return;
      var selection = this.canSelectItem(mappedKey) ? new (0, $e40ea825a81a3709$export$52baac22726c72bf)([mappedKey], mappedKey, mappedKey) : new (0, $e40ea825a81a3709$export$52baac22726c72bf)();
      this.state.setSelectedKeys(selection);
    }
    /**
    * Replaces the selection with the given keys.
    */
  }, {
    key: "setSelectedKeys",
    value: function setSelectedKeys(keys) {
      if (this.selectionMode === 'none') return;
      var selection = new (0, $e40ea825a81a3709$export$52baac22726c72bf)();
      var _iterator3 = _createForOfIteratorHelper(keys),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value;
          var mappedKey = this.getKey(key);
          if (mappedKey != null) {
            selection.add(mappedKey);
            if (this.selectionMode === 'single') break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getSelectAllKeys",
    value: function getSelectAllKeys() {
      var _this = this;
      var keys = [];
      var _addKeys = function addKeys(key) {
        while (key != null) {
          if (_this.canSelectItem(key)) {
            var _getFirstItem;
            var item = _this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === 'item') keys.push(key);
            var _getFirstItem_key;
            // Add child keys. If cell selection is allowed, then include item children too.
            if ((item === null || item === void 0 ? void 0 : item.hasChildNodes) && (_this.allowsCellSelection || item.type !== 'item')) _addKeys((_getFirstItem_key = (_getFirstItem = (0, $jkhUT$getFirstItem)((0, $jkhUT$getChildNodes)(item, _this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null);
          }
          key = _this.collection.getKeyAfter(key);
        }
      };
      _addKeys(this.collection.getFirstKey());
      return keys;
    }
    /**
    * Selects all items in the collection.
    */
  }, {
    key: "selectAll",
    value: function selectAll() {
      if (!this.isSelectAll && this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
    }
    /**
    * Removes all keys from the selection.
    */
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $e40ea825a81a3709$export$52baac22726c72bf)());
    }
    /**
    * Toggles between select all and an empty selection.
    */
  }, {
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      if (this.isSelectAll) this.clearSelection();else this.selectAll();
    }
  }, {
    key: "select",
    value: function select(key, e) {
      if (this.selectionMode === 'none') return;
      if (this.selectionMode === 'single') {
        if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);else this.replaceSelection(key);
      } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual'))
        // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
        this.toggleSelection(key);else this.replaceSelection(key);
    }
    /**
    * Returns whether the current selection is equal to the given selection.
    */
  }, {
    key: "isSelectionEqual",
    value: function isSelectionEqual(selection) {
      if (selection === this.state.selectedKeys) return true;
      // Check if the set of keys match.
      var selectedKeys = this.selectedKeys;
      if (selection.size !== selectedKeys.size) return false;
      var _iterator4 = _createForOfIteratorHelper(selection),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var key = _step4.value;
          if (!selectedKeys.has(key)) return false;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var _iterator5 = _createForOfIteratorHelper(selectedKeys),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _key2 = _step5.value;
          if (!selection.has(_key2)) return false;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return true;
    }
  }, {
    key: "canSelectItem",
    value: function canSelectItem(key) {
      var _item_props;
      if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
      var item = this.collection.getItem(key);
      if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === 'cell' && !this.allowsCellSelection) return false;
      return true;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(key) {
      var _this_collection_getItem_props, _this_collection_getItem;
      return this.state.disabledBehavior === 'all' && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
    }
  }, {
    key: "isLink",
    value: function isLink(key) {
      var _this_collection_getItem_props, _this_collection_getItem;
      return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
  }, {
    key: "getItemProps",
    value: function getItemProps(key) {
      var _this_collection_getItem;
      return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
    }
  }, {
    key: "selectionMode",
    /**
    * The type of selection that is allowed in the collection.
    */
    get: function get() {
      return this.state.selectionMode;
    }
    /**
    * Whether the collection allows empty selection.
    */
  }, {
    key: "disallowEmptySelection",
    get: function get() {
      return this.state.disallowEmptySelection;
    }
    /**
    * The selection behavior for the collection.
    */
  }, {
    key: "selectionBehavior",
    get: function get() {
      return this.state.selectionBehavior;
    }
  }, {
    key: "isFocused",
    get: function get() {
      return this.state.isFocused;
    }
  }, {
    key: "focusedKey",
    get: function get() {
      return this.state.focusedKey;
    } /** Whether the first or last child of the focused key should receive focus. */
  }, {
    key: "childFocusStrategy",
    get: function get() {
      return this.state.childFocusStrategy;
    }
  }, {
    key: "selectedKeys",
    get: function get() {
      return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
    * The raw selection value for the collection.
    * Either 'all' for select all, or a set of keys.
    */
  }, {
    key: "rawSelection",
    get: function get() {
      return this.state.selectedKeys;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
    * Whether all items in the collection are selected.
    */
  }, {
    key: "isSelectAll",
    get: function get() {
      if (this.isEmpty) return false;
      if (this.state.selectedKeys === 'all') return true;
      if (this._isSelectAll != null) return this._isSelectAll;
      var allKeys = this.getSelectAllKeys();
      var selectedKeys = this.state.selectedKeys;
      this._isSelectAll = allKeys.every(function (k) {
        return selectedKeys.has(k);
      });
      return this._isSelectAll;
    }
  }, {
    key: "firstSelectedKey",
    get: function get() {
      var first = null;
      var _iterator6 = _createForOfIteratorHelper(this.state.selectedKeys),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value;
          var item = this.collection.getItem(key);
          if (!first || item && (0, $jkhUT$compareNodeOrder)(this.collection, item, first) < 0) first = item;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      var _first_key;
      return (_first_key = first === null || first === void 0 ? void 0 : first.key) !== null && _first_key !== void 0 ? _first_key : null;
    }
  }, {
    key: "lastSelectedKey",
    get: function get() {
      var last = null;
      var _iterator7 = _createForOfIteratorHelper(this.state.selectedKeys),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var key = _step7.value;
          var item = this.collection.getItem(key);
          if (!last || item && (0, $jkhUT$compareNodeOrder)(this.collection, item, last) > 0) last = item;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      var _last_key;
      return (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
  }, {
    key: "disabledKeys",
    get: function get() {
      return this.state.disabledKeys;
    }
  }, {
    key: "disabledBehavior",
    get: function get() {
      return this.state.disabledBehavior;
    }
  }]);
  function $d496c0a20b6e58ec$export$6c8a5aaad13c9852(collection, state, options) {
    _classCallCheck(this, $d496c0a20b6e58ec$export$6c8a5aaad13c9852);
    this.collection = collection;
    this.state = state;
    var _options_allowsCellSelection;
    this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
    this._isSelectAll = null;
    this.layoutDelegate = (options === null || options === void 0 ? void 0 : options.layoutDelegate) || null;
  }
  return $d496c0a20b6e58ec$export$6c8a5aaad13c9852;
}();
export { $d496c0a20b6e58ec$export$6c8a5aaad13c9852 as SelectionManager };